import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const countingtruckseldConfig: TSPConfig = {
  key: 'countingtruckseld',
  name: 'CountingTrucksELD',
  imageName: 'countingtruckseld',
  category: TSPCategory.API_KEY,
  helpText:
    'Please request an API key from CountingTrucksELD support, then enter it below.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default countingtruckseldConfig;
